function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  appearance: none;\n  background: none;\n  border: none;\n  border-radius: 0;\n  padding: 0;\n  font-weight: 400;\n  font-size: ",
        ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: ",
        ";\n  &:hover,\n  &:focus,\n  &:active {\n    cursor: pointer;\n    color: ",
        ";\n    outline: none;\n    border: none;\n    box-shadow: none;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Button } from 'rebass/styled-components';
import styled from 'styled-components';
export default styled(function(props) {
    return /*#__PURE__*/ _jsx(Button, _object_spread({}, props));
})(_templateObject(), function(props) {
    var _props_fontSize;
    return (_props_fontSize = props.fontSize) !== null && _props_fontSize !== void 0 ? _props_fontSize : '13px';
}, function(props) {
    return props.color;
}, function(props) {
    return props.color ? props.color : '#363636';
});
